import styled from "@emotion/styled";
var LogoWrapper = /*#__PURE__*/ styled("div", {
    target: "e106cohp0"
})("display:flex;align-items:center;justify-content:center;gap:0.5rem;font-size:0.75rem;img{height:30px;vertical-align:middle;}a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";}");
export { LogoWrapper };
